import { QueryClient } from '@tanstack/react-query';

/**
 * `queryClient` is imported in the root for `QueryClientProvider` and to be used in class based components. Ideally we should be using the `useQueryClient` hook to get the query client. all imports except the root should be removed once we have migrated all required components to function based
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 2,
    },
  },
});

export default queryClient;
